<template>
  <div :class="['d-flex', alignClass]">
    <v-btn
      v-bind="$attrs"
      v-on="$listeners"
      :class="[
        'button-widget px-14 font-weight-regular text-none text-body-1',
        secondary && 'grey--text text--darken-4',
      ]"
      :color="!secondary ? 'primary' : 'secondary'"
      height="48px"
      rounded
      depressed
      :type="type"
    >
      <slot />
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: "left",
      validator: (val) => ["left", "center", "right"].includes(val),
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
  },
  computed: {
    alignClass() {
      const classes = {
        left: "justify-start",
        center: "justify-center",
        right: "justify-end",
      };

      return classes[this.align];
    },
  },
};
</script>

<style>
.button-widget {
  box-shadow: 0px 4px 8px rgba(109, 78, 134, 0.25);
}
</style>
